import { Button, Loader, Table } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import Api from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import NewVendorDrawer from './vendors/New';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Vendors = ({ carrier }) => {
  const navigate = useNavigate();
  const { setNotification } = useContext(CarrierContext);
  const [relationships, setRelationships] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show_new_vendor, toggleNewRelationship] = useState(false);

  useEffect(() => {
    loadRelationships();
  }, []);

  const loadRelationships = () => {
    setLoading(true);

    Api.loadVendorCarrierRelationships({ carrier_id: carrier.id }).then(({ data }) => {
      setRelationships(data);

      Api.loadVendors({ excluded_carrier_id: carrier.id }).then(({ data }) => {
        setVendors(data);
        setLoading(false);
      });
    });
  };

  const toggleDeactivate = (vendor, e) => {
    e.stopPropagation();

    Api.updateVendorCarrierRelationship(vendor.id, { is_deactivated: !vendor.is_deactivated }).then(
      () => {
        loadRelationships();
        setNotification(ACTION_MESSAGES.CARRIERS.VENDOR.DEACTIVATED(!vendor.is_deactivated));
      }
    );
  };

  const handleCreate = () => {
    setNotification(ACTION_MESSAGES.CARRIERS.VENDOR.SAVE);
    toggleNewRelationship(null);
    loadRelationships();
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <NewVendorDrawer
        carrier={carrier}
        onClose={toggleNewRelationship.bind(null, false)}
        onSave={handleCreate}
        show={show_new_vendor}
        vendors={vendors}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={toggleNewRelationship.bind(null, {
            first_name: '',
            last_name: '',
            email: '',
            carrier_id: carrier.id
          })}
        >
          Add Vendor Relationship
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            is_sortable: true,
            label: 'Name'
          },
          {
            id: 'id',
            label: 'Relationship ID'
          },
          {
            id: 'vendor_id',
            label: 'Vendor Token'
          },
          {
            id: 'api_token',
            label: 'Carrier Token'
          },
          {
            id: 'actions',
            render: relationship => {
              return (
                <Button
                  color={relationship.is_deactivated ? 'SECONDARY' : 'RED'}
                  onClick={toggleDeactivate.bind(null, relationship)}
                  small={true}
                >
                  {relationship.is_deactivated ? 'Activate' : 'Deactivate'}
                </Button>
              );
            },
            styles: { textAlign: 'right' },
            width: 100
          }
        ]}
        data={relationships}
        defaultSortColumn={{ id: 'name' }}
        onRowClick={r => navigate(`${r.id}`)}
        placeholder='No vendor relationships created yet'
      />
    </>
  );
};

Vendors.propTypes = {
  carrier: PropTypes.object
};

export default Vendors;
